export default "__VITE_ASSET__DNrXOjHm__"